import React, { ReactNode } from "react";
import { Box, createMultiStyleConfigHelpers, Flex, Switch } from "@chakra-ui/react";
import { switchAnatomy } from "@chakra-ui/anatomy";

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
  firstOption?: string | ReactNode;
  secondOption?: string | ReactNode;
  width?: string;
}

export default function CurrencySwitch({
  checked,
  onChange,
  firstOption,
  secondOption,
  width,
}: Props) {
  return (
    <Switch
      variant={"currency"}
      width={width ?? getDefaultWidth(firstOption, secondOption)}
      height={"28px"}
      cursor={"pointer"}
      isChecked={checked}
      onChange={(value) => onChange(value.target.checked)}
    >
      <Box
        display={"flex"}
        width={"100%"}
        height={"100%"}
        position={"absolute"}
        top={0}
      >
        <Flex
          flex={1}
          justifyContent={"center"}
          alignItems={"center"}
          textStyle={`body-md-${checked ? "regular" : "semi-bold"}`}
        >
          {firstOption || "€"}
        </Flex>
        <Flex
          flex={1}
          justifyContent={"center"}
          alignItems={"center"}
          textStyle={`body-md-${checked ? "semi-bold" : "regular"}`}
        >
          {secondOption || "₩"}
        </Flex>
      </Box>
    </Switch>
  );
}

// 한 칸(전체의 절반)에 기호가 들어가도록 폭을 잡는다 — €·₩ 같은 한 글자는 기존 48px 그대로,
// HK$ 처럼 긴 기호는 글자 수만큼 넓힌다. ReactNode 옵션은 크기를 알 수 없어 width 를 직접 넘겨야 한다.
const getDefaultWidth = (
  firstOption: Props["firstOption"],
  secondOption: Props["secondOption"]
) => {
  const labelLength = Math.max(
    typeof firstOption === "string" ? firstOption.length : 1,
    typeof secondOption === "string" ? secondOption.length : 1
  );
  const halfWidth = Math.max(24, labelLength * 10 + 12);
  return `${halfWidth * 2}px`;
};

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(switchAnatomy.keys);

const currency = definePartsStyle({
  container: {
    w: "48px",
    h: "28px",
  },
  track: {
    boxSizing: "border-box",
    w: "100%",
    h: "100%",
    p: "2px",
    border: "1px solid #D4D4D1",
    borderRadius: "4px",
    _checked: {
      bg: "#F7F9FA",
    },
    bg: "#F7F9FA",
  },
  thumb: {
    boxSizing: "border-box",
    w: "50%",
    h: "24px",
    bg: "#FFFFFF",
    borderRadius: "2px",
    _checked: {
      transform: "translateX(100%)",
    },
    label: {
      position: "relative",
    },
  },
});

// @ts-ignore
export const switchTheme = defineMultiStyleConfig({
  variants: {
    currency,
  },
});
